import React from "react";
import { View } from "react-native";

import Text from "component/typography/Text";
import Icon from "component/typography/Icon";
import Button from "component/button/Button";

import { css } from "style";
import { colors, sizes } from "asset/constant";
import { mq } from "utils";

export default function ConfirmAlertCard(props: {
  icon: IconT;
  title: string;
  message: string;
  subMessage?: string;
  yesTitle: string;
  noTitle: string;
  onYesPress: () => void;
  onNoPress: () => void;
  renderContent?: () => JSX.Element;
}) {
  const {
    icon,
    title,
    message,
    subMessage,
    yesTitle,
    noTitle,
    onNoPress,
    onYesPress,
    renderContent,
  } = props;

  return (
    <View style={{ ...css.centralElements, maxWidth: 400 }}>
      {renderContent ? (
        renderContent()
      ) : (
        <>
          <Icon color={colors.theme} size={20} {...icon} />
          <Text align="center" weight="extraBold" size={"xl"}>
            {title}
          </Text>

          <View
            style={{
              marginTop: mq(15),
              marginBottom: mq(30),
              ...css.centralElements,
            }}
          >
            <Text
              align="center"
              style={{ lineHeight: mq(25) }}
              size={"lg"}
              weight="bold"
            >
              {message}. {subMessage}
            </Text>
          </View>

          <View
            style={{
              ...css.fitWidth,
              ...css.rowCenterAlign,
              ...css.justifySpaceEvenly,
            }}
          >
            <Button
              onPress={onYesPress}
              width={"40%"}
              bgColor={colors.danger}
              title={{ value: yesTitle, size: "sm" }}
            />
            <View style={{ width: sizes.space }} />
            <Button
              onPress={onNoPress}
              width={"40%"}
              bgColor={colors.white}
              bordered={{ width: mq(1), color: colors.danger }}
              title={{ value: noTitle, size: "sm", color: colors.danger }}
            />
          </View>
        </>
      )}
    </View>
  );
}
